export default __webpack_public_path__ + "static/media/a008-4.6742bb01.svg";